/* Native cart attributes save the acceptance together with quantities and order notes.
   This is a storefront cart gate, not a Shopify checkout validation extension. */
(function () {
  'use strict';
  function validate(form) {
    var checkbox = form.querySelector('[data-refund-checkbox]');
    if (!checkbox) return true;
    var error = form.querySelector('[data-refund-error]');
    if (error) error.hidden = checkbox.checked;
    checkbox.setAttribute('aria-invalid', checkbox.checked ? 'false' : 'true');
    if (!checkbox.checked) {
      checkbox.focus();
      return false;
    }
    return true;
  }
  // Capture before legacy theme and app click/submit listeners run.
  document.addEventListener('click', function (event) {
    var button = event.target.closest('[name="checkout"]');
    if (button && button.form && !validate(button.form)) {
      event.preventDefault();
      event.stopImmediatePropagation();
    }
  }, true);
  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (!form.querySelector('[data-refund-checkbox]')) return;
    if (event.submitter && event.submitter.name === 'update') return;
    if (!validate(form)) {
      event.preventDefault();
      event.stopImmediatePropagation();
    }
  }, true);
  document.addEventListener('change', function (event) {
    if (!event.target.matches('[data-refund-checkbox]')) return;
    var error = event.target.closest('[data-refund-agreement]').querySelector('[data-refund-error]');
    if (error) error.hidden = true;
    event.target.removeAttribute('aria-invalid');
  });
  // Browser history must not restore a prior acceptance automatically.
  window.addEventListener('pageshow', function () {
    document.querySelectorAll('[data-refund-checkbox]').forEach(function (checkbox) {
      checkbox.checked = false;
      checkbox.removeAttribute('aria-invalid');
      var error = checkbox.closest('[data-refund-agreement]').querySelector('[data-refund-error]');
      if (error) error.hidden = true;
    });
  });
})();
